import React, { useEffect, useState } from "react";
import { Box, Button, FormControl, FormHelperText } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Footer } from "../components/Footer";
import { format } from "date-fns";

export function EventDates({
  handleNext,
  handleBack,
  activeStep,
  isStepOptional,
  steps,
  totalFormData,
  handleDataSubmitted,
}: {
  handleNext: () => void;
  handleBack: () => void;
  activeStep: number;
  isStepOptional: (step: number) => boolean;
  steps: string[];
  totalFormData: Record<string, any>;
  handleDataSubmitted: (data: Record<string, any>, step: string) => void;
}) {
  const [admissionDate, setAdmissionDate] = useState<Date | null>(new Date());
  const [dischargeDate, setDischargeDate] = useState<Date | null>(new Date());
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    if (totalFormData["event-dates"]) {
      const prev = totalFormData["event-dates"];
      setAdmissionDate(
        prev.admissionDate ? new Date(prev.admissionDate) : new Date()
      );
      setDischargeDate(
        prev.dischargeDate ? new Date(prev.dischargeDate) : new Date()
      );
    }
  }, [totalFormData]);

  const validate = () => {
    const errors: Record<string, string> = {};
    if (!admissionDate) errors["admission-date"] = "Admission date is required";
    if (!dischargeDate) errors["discharge-date"] = "Discharge date is required";
    if (admissionDate && dischargeDate && admissionDate > dischargeDate) {
      errors["discharge-date"] = "Discharge date must be after admission date";
    }
    return errors;
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    setFormErrors({});
    handleDataSubmitted(
      {
        admissionDate: admissionDate ? format(admissionDate, "dd/MM/yyyy") : "",
        dischargeDate: dischargeDate ? format(dischargeDate, "dd/MM/yyyy") : "",
      },
      "event-dates"
    );
    handleNext();
  };

  return (
    <>
      <h4 style={{ borderBottom: "1px solid #ccc", margin: "1em 0" }}>
        Enter event dates
      </h4>
      <form onSubmit={handleSubmit} style={{ paddingBottom: "5em" }}>
        <h5>Admission date</h5>
        <FormControl
          sx={{
            m: { xs: 0, sm: 1 },
            mb: { xs: 1, sm: 1 },
            width: { xs: 300, sm: 600 },
            minWidth: { xs: "100%", sm: "auto" },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              format="dd/MM/yyyy"
              value={admissionDate}
              onChange={(d) => setAdmissionDate(d)}
            />
          </LocalizationProvider>
          {formErrors["admission-date"] && (
            <FormHelperText error>
              {formErrors["admission-date"]}
            </FormHelperText>
          )}
        </FormControl>

        <h5>Discharge date</h5>
        <FormControl
          sx={{
            m: { xs: 0, sm: 1 },
            mb: { xs: 1, sm: 1 },
            width: { xs: 300, sm: 600 },
            minWidth: { xs: "100%", sm: "auto" },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              format="dd/MM/yyyy"
              value={dischargeDate}
              onChange={(d) => setDischargeDate(d)}
            />
          </LocalizationProvider>
          {formErrors["discharge-date"] && (
            <FormHelperText error>
              {formErrors["discharge-date"]}
            </FormHelperText>
          )}
        </FormControl>

        <Box sx={{ display: "flex", flexDirection: "row", py: 2, mb: "10em" }}>
          <Button
            color="inherit"
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{ mr: 1, fontSize: "1.2em" }}
          >
            Back
          </Button>
          <Box sx={{ flex: "1 1 auto" }} />
          <Button type="submit" sx={{ fontSize: "1.2em" }}>
            Next
          </Button>
        </Box>
      </form>
      <Footer />
    </>
  );
}



